import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { RIESelect } from 'riek';
import queryString from 'query-string';
import { withRouter } from 'react-router';

import history from 'shared_history';
import { modals, tasks as tasksDuck, users as usersDuck } from 'ducks/index';
import {
  dependentDuck,
  duckify,
  filterDuck,
  singleDuck
} from 'utils/duckify';

import WidgetHeader from 'components/WidgetHeader/WidgetHeader';
import ReminderList from './ReminderList';

import './UserReminders.scss';

const UserReminders = ({
  currentUser,
  location,
  onDestroy,
  onSave,
  reminders,
  users
}) => {
  const query = queryString.parse(location.search);
  const userId = query.user_id || currentUser.id;
  const user = [{ id: 'all', name: 'All Users' }].concat(users).find((u) => u.id === userId) || {};
  const selectedUser = users.ready ? { id: user.id, text: user.name } : {};

  const setUser = (id) => {
    const newQuery = {
      ...query,
      user_id: id
    };

    history.push({
      ...location,
      search: `?${queryString.stringify(newQuery)}`
    });
  };

  return (
    <div>
      <WidgetHeader text='Reminders' />
      <div className='reminder-tagline'>Upcoming tasks and reminders</div>

      <div>
        <span className='reminder-list-selector-description'>
          Viewing reminders for:
        </span>
        {
          users.ready && (
            <RIESelect
              value={selectedUser}
              propName='value'
              change={({ value: { id } }) => setUser(id)}
              options={[{ id: 'all', text: 'All Users' }].concat(users.map((u) => ({ id: u.id, text: u.name })))}
              className='user-reminders-selector'
            />
          )
        }
      </div>

      {
        <ReminderList
          reminders={reminders}
          onDestroy={onDestroy(`user_id=${user.id}`)}
          onSave={onSave(`user_id=${user.id}`)}
          users={users}
          showContact
        />
      }
    </div>
  );
};

UserReminders.defaultProps = {
  currentUser: { id: '' },
  location: { search: '' },
  onDestroy: () => false,
  onSave: () => false,
  reminders: [],
  users: []
};

UserReminders.propTypes = {
  currentUser: PropTypes.shape({
    id: PropTypes.string
  }),
  location: PropTypes.shape({
    search: PropTypes.string
  }),
  onDestroy: PropTypes.func,
  onSave: PropTypes.func,
  reminders: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string
    })
  ),
  users: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string
    })
  )
};

const mapDucksToProps = ({ location: { search } }) => {
  const query = queryString.parse(search);
  const userId = query.user_id === 'all' ? '' : query.user_id;
  const currentUserDuck = singleDuck(usersDuck, 'current');

  return {
    currentUser: currentUserDuck,
    reminders: userId === '' || userId
      ? filterDuck(tasksDuck, { user_id: userId })
      : dependentDuck(currentUserDuck, ({ value: user }) => filterDuck(tasksDuck, { user_id: user.id })),
    users: filterDuck(usersDuck, { type: 'Admin' })
  };
};

const mapDispatchToProps = (dispatch) => ({
  onDestroy: (stateKey) => (task) => dispatch(modals.actions.show('VerificationModal', {
    title: 'Are you sure?',
    message: (
      <p>
        Deleting this reminder will&nbsp;
        <strong>permanently</strong>
        &nbsp;remove it from the system. If you have completed this task, instead use
        the checkbox to mark the item completed.
      </p>
    ),
    onConfirm: () => dispatch(tasksDuck.actions.remove(task, stateKey === 'user_id=all'
      ? 'user_id='
      : stateKey)).catch(() => false)
  })),
  onSave: (stateKey) => (task) => dispatch(tasksDuck.actions.save(task, {}, stateKey))
});

export default compose(
  withRouter,
  duckify(mapDucksToProps, () => ({}), mapDispatchToProps)
)(UserReminders);
